const initialState = {
    amount:null
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_PAYMENT_AMOUNT":
      return {
        ...state,
        amount: action.data,
      };
      break
    case "SET_PAYMENT_CONFIG_DATA":
      return {
        ...state,
        paymentConfig:action.data
      }
    default:
      return state;
  }
}
